import React from 'react';
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, FormGroup, Paper, Stack, SvgIcon, TextField } from '@mui/material';
import { useEditorState } from 'react-simple-wysiwyg';

export default function AppBarDialog(props) {
    const { open, setOpen, data, action } = props

    const [mainMenu, setMainMenu] = React.useState(false);
    const [titulo, setTitulo] = React.useState('');
    const [menu, setMenu] = React.useState('');
    const [login, setLogin] = React.useState(false);
    const [profile, setProfile] = React.useState(false);
    const [lightModeColor, setLightModeColor]= React.useState('');
    const [darkModeColor, setDarkModeColor]= React.useState('');
    const [darkMode, setDarkMode]= React.useState(false);
    React.useEffect(() => {
        if (open) {
            console.log( data, data);
            setMainMenu(data.data.mainMenu);
            setTitulo(data.data.titulo);
            setMenu(data.data.headerMenu);
            setLogin(data.data.login);
            setProfile(data.data.profile);
            setDarkMode(data.data.darkMode);
            setDarkModeColor(data.data.iconColorDark);
            setLightModeColor(data.data.iconColorLight);
        }
    }, [open]);
    function handleClose() {
        setOpen(false);
    }
    const handleSubmit = (event) => {
        event.preventDefault();
        if (action) action({
            mainMenu: mainMenu,
            titulo: titulo,
            headerMenu: menu,
            login: login,
            profile: profile,
            darkMode: darkMode,
            iconColorLight: lightModeColor,
            iconColorDark: darkModeColor
        });


        document.getElementById('appBar-mainMenu').checked = mainMenu;
        document.getElementById('appBar-loginLogout').checked = login;
        document.getElementById('appBar-profile').checked = profile;
        document.getElementById('appBar-titulo').value = titulo;
        document.getElementById('appBar-menu').value = menu;

        handleClose();
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Edição {data.tipo} </DialogTitle>
            <DialogContent sx={{ paddingBottom: 0 }}>
                <DialogContentText>
                    Defina os itens que apareceram no AppBar da aplicação
                </DialogContentText>
                <Stack>
                    <FormGroup>
                        <FormControlLabel control={
                            <Checkbox autoFocus checked={mainMenu} onChange={(e) => setMainMenu(e.target.checked)} />
                        } label="Menu esquerdo" />
                    </FormGroup>
                    <TextField
                        margin="dense"
                        label="Titulo da Barra"
                        fullWidth
                        variant="standard"
                        value={titulo} onChange={(e) => setTitulo(e.target.value)}
                    />
                    <TextField
                        margin="dense"
                        label="Menu da Barra"
                        fullWidth
                        variant="standard"
                        value={menu} onChange={(e) => setMenu(e.target.value)}
                    />
                    <FormGroup>
                        <FormControlLabel control={
                            <Checkbox autoFocus checked={login} onChange={(e) => setLogin(e.target.checked)} />
                        } label="Login/Logout" />
                    </FormGroup>
                    <FormGroup>
                        <FormControlLabel control={
                            <Checkbox autoFocus checked={profile} onChange={(e) => setProfile(e.target.checked)} />
                        } label="Profile" />
                    </FormGroup>
                    <FormGroup>
                        <FormControlLabel control={
                            <Checkbox autoFocus checked={darkMode} onChange={(e) => setDarkMode(e.target.checked)} />
                        } label="DarkMode" />
                    </FormGroup>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            margin="dense"
                            label="Cor do Icone LightMode"
                            variant="standard"
                            value={lightModeColor||''} onChange={(e) => setLightModeColor(e.target.value)}
                        />
                        <TextField
                            margin="dense"
                            label="Cor Icone DarkMode"                            
                            variant="standard"
                            value={darkModeColor||''} onChange={(e) => setDarkModeColor(e.target.value)}
                        />
                    </Stack>
                </Stack>
                <DialogActions>
                    <Button onClick={handleClose}>Cancelar</Button>
                    <Button onClick={handleSubmit}>Salvar</Button>
                </DialogActions>

            </DialogContent>
        </Dialog>

    )
}